import { createFileRoute } from '@tanstack/react-router';

import { requireAdmin } from '@/components/admin/require-admin.ts';
import { DashboardView } from '@/views/admin/dashboard-view.tsx';

// ADMIN-only: the dashboard's stats endpoint is ADMIN-scoped (ADR-018). A TEACHER
// who navigates here directly is bounced to /admin/courses by requireAdmin.
export const Route = createFileRoute('/admin/dashboard')({
  beforeLoad: requireAdmin,
  component: DashboardView,
});
